import React from "react";
import { Box, Typography } from "@mui/material";
import PaynamicsImg1 from "../../assets/paynamics/PaynamicsImg1";

const PaynamicsFailedPage: React.FC = () => {
  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        marginTop: "20px",
      }}
    >
      <PaynamicsImg1 />
      <Box sx={{ width: "50%", textAlign: "center", marginTop: "20px" }}>
        <Typography variant="h4">Transaction Failed</Typography>
        <Typography variant="h5">
          We couldn't process your transaction at this time. Please try again.
        </Typography>
      </Box>
    </Box>
  );
};

export default PaynamicsFailedPage;
